import { createReducer } from 'actionware';
import update from 'immutability-helper';
import {
  fetchLenderAccount,
  fetchLenderAccounts,
  fetchLoan,
  fetchLoans,
  fetchStatistics,
  filterDisplayedLoans,
  setSelectedAccount
} from './accountActions';
import { updatePreferences } from './../accountCreation/accountCreationActions'
import { createState } from 'stateware';

const initialState = createState({
  accounts: [],
  selectedAccountId: null,
  selectedAccountDetails: {},
  statistics: [],
  loans: [],
  activeLoans({ loans }) {
    return loans.filter(loan => loan.status === 'disbursed');
  },
  repaidLoans({ loans }) {
    return loans.filter(loan => loan.status === 'closed');
  },
  selectedLoanDetails: {},
  displayingActiveLoans: true
});

export default createReducer(initialState)
  .on(fetchLenderAccounts, (state, accounts) =>
    initialState.copy({
      accounts
    })
  )
  .on(fetchLenderAccount, (state, selectedAccountDetails) =>
    state.copy({
      selectedAccountDetails
    })
  )
  .on(setSelectedAccount, (state, selectedAccountId) =>
    state.copy({
      selectedAccountId
    })
  )
  .on(fetchStatistics, (state, statistics) =>
    state.copy({
      statistics
    })
  )
  .on(fetchLoans, (state, loans) =>
    state.copy({
      loans
    })
  )
  .on(fetchLoan, (state, selectedLoanDetails) =>
    state.copy({
      selectedLoanDetails
    })
  )
  .on(filterDisplayedLoans, (state, displayActive) =>
    state.copy({
      displayingActiveLoans: displayActive
    })
  )
  .on(updatePreferences, (state, payload) => {
    return state.copy({
      selectedAccountDetails: update(state.selectedAccountDetails, { $merge: payload })
    })
  })
